import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { AuthAbstractComponent } from '../abstracts/auth.abstract';
import { AuthFacade } from '../auth.facade';
import { LoginComponent } from '../components/login/login.component';

@Component({
	selector: 'app-auth-layout',
	templateUrl: './auth-layout.component.html',
	styleUrls: ['./auth-layout.component.scss'],
	providers: [AuthFacade],
})
export class AuthLayoutComponent extends AuthAbstractComponent implements OnInit, AfterViewInit, OnDestroy {
	constructor() {
		super();
	}

	ngOnInit(): void {
		setTimeout(() => {
			this.authFacade.setToggleHeaderLogin(false);
		});
	}

	override ngAfterViewInit(): void {
		super.ngAfterViewInit();
		this.loadComponent(LoginComponent);
	}

	ngOnDestroy(): void {
		this.authFacade.setToggleHeaderLogin(true);
	}
}
